WiseMetering.Views.ShowDesigoConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/desigo/show',
    title: () => i18next.t('modal.title.integration_configurations.show')
});
